import { render, staticRenderFns } from "./ModalDuplicateItem.vue?vue&type=template&id=132a5dce&scoped=true"
import script from "./ModalDuplicateItem.vue?vue&type=script&lang=js"
export * from "./ModalDuplicateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a5dce",
  null
  
)

export default component.exports